var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer clearfix",style:({ 'height': _vm.height})},[_c('el-pagination',{staticClass:"footer-pagination fr",attrs:{"page-size":_vm.propsPageSize,"layout":"prev, pager, next, jumper","total":_vm.propsTotalCols},on:{"current-change":_vm.CurrentPageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }